import React from 'react';
import Tooltip from '../../../../../ui/tooltip/Tooltip';
import classes from './StudentNameCell.module.css';

const StudentNameCell = ({ value }) => {

  const originalText = String(value || '');

  return (
    <Tooltip text={originalText} showTooltip={true} className={classes.studentNameCellTooltip}>
      <div className={classes.studentNameCell}>
        {originalText}
      </div>
    </Tooltip>
  );
};

export default StudentNameCell;
